import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "basic"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#basic" }),
  /*#__PURE__*/_createTextVNode(" Basic ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".pulse"),
  /*#__PURE__*/_createTextVNode(" with for any element to provide a user's attentation. ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10 pb-0 d-flex align-items-center flex-wrap" }
const _hoisted_6 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_9 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_12 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_15 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_16 = { class: "svg-icon svg-icon-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_18 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_19 = { class: "svg-icon svg-icon-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_21 = {
  href: "#",
  class: "btn btn-icon btn-light pulse me-10 mb-10"
}
const _hoisted_22 = { class: "svg-icon svg-icon-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring" }, null, -1)
const _hoisted_24 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks.svg" })
          ]),
          _hoisted_8
        ]),
        _createElementVNode("a", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Done-circle.svg" })
          ]),
          _hoisted_11
        ]),
        _createElementVNode("a", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Mail-error.svg" })
          ]),
          _hoisted_14
        ]),
        _createElementVNode("a", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Color-profile.svg" })
          ]),
          _hoisted_17
        ]),
        _createElementVNode("a", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/PenAndRuller.svg" })
          ]),
          _hoisted_20
        ]),
        _createElementVNode("a", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Files/File.svg" })
          ]),
          _hoisted_23
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<a href="#" class="btn btn-icon btn-light pulse">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring"></span> </a
        >`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}